import { ToastState } from "./types";

export const TOAST_INITIAL_STATE: ToastState = {
  title: "",
  message: "",
  type: "success",
  isOpen: false,
};
